// Card data types — discriminated union for the examples grid

export type ImageCardData = {
	type: "image";
	imageSrc: string;
	imageAlt: string;
	category: string;
	title: string;
	description: string;
	textPosition: "overlay" | "below";
};

export type CircleImageCardData = {
	type: "circle-image";
	imageSrc: string;
	imageAlt: string;
	category: string;
	title: string;
	description: string;
};

export type QuoteCardData = {
	type: "quote";
	icon: string;
	category: string;
	quote: string;
	attribution: string;
	variant: "blockquote" | "serif";
};

export type InsightCardData = {
	type: "insight";
	icon: string;
	category: string;
	text: string;
	attribution?: string;
};

export type ExtractionLinkData = {
	type: "extraction-link";
};

export type CardItem =
	| ImageCardData
	| CircleImageCardData
	| QuoteCardData
	| InsightCardData
	| ExtractionLinkData;

export type ExampleColumn = {
	span: number;
	offsetTop?: string;
	cards: CardItem[];
};

export const EXAMPLE_COLUMNS: ExampleColumn[] = [
	{
		span: 5,
		cards: [
			{
				type: "image",
				imageSrc: "/landing/altman.jpg",
				imageAlt: "Abstract nature",
				category: "Strategy Extraction",
				title: "The Sovereignty of Digital Wealth",
				description:
					"A synthesis on why status is a zero-sum game while wealth creates positive leverage.",
				textPosition: "below",
			},
			{
				type: "quote",
				icon: "auto_awesome",
				category: "Core Thesis",
				quote: "\u201CWealth is assets that earn while you sleep. Money is how we transfer time. Status is your place in the social hierarchy.\u201D",
				attribution: "N. Ravikant \u2014 12:45",
				variant: "blockquote",
			},
			{
				type: "extraction-link",
			},
		],
	},
	{
		span: 3,
		offsetTop: "lg:mt-32",
		cards: [
			{
				type: "image",
				imageSrc: "/landing/kaparthy.webp",
				imageAlt: "Neural visual",
				category: "AI Synthesis",
				title: "Linguistic Programming",
				description:
					"English as the ultimate high-level language in the era of large-scale reasoning models.",
				textPosition: "below",
			},
			{
				type: "insight",
				icon: "psychology",
				category: "Observation",
				text: "Prompt engineering effectively replaces syntax mastery for many high-level cognitive tasks.",
				attribution: "A. Karpathy \u2014 Archive #333",
			},
			{
				type: "extraction-link",
			},
		],
	},
	{
		span: 4,
		offsetTop: "lg:mt-12",
		cards: [
			{
				type: "image",
				imageSrc: "/landing/a16z.webp",
				imageAlt: "Lab glass",
				category: "Bio-Optimization",
				title: "The Circadian Anchor",
				description:
					"Why photons are the most potent chemical signal for human performance.",
				textPosition: "below",
			},
			{
				type: "quote",
				icon: "light_mode",
				category: "Protocol",
				quote: "Viewing morning sunlight within the first hour of waking is the single most important thing you can do for your sleep-wake cycle.",
				attribution: "A. Huberman \u2014 15:00",
				variant: "serif",
			},
			{
				type: "insight",
				icon: "trending_up",
				category: "Future Cast",
				text: "Non-sleep deep rest (NSDR) will become a standard corporate wellness practice within the next half-decade.",
			},
			{
				type: "extraction-link",
			},
		],
	},
];
